import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
const JapanPostalCodeMark = () => {
  return /*#__PURE__*/React.createElement(Text, null, '\u3012');
};
export default JapanPostalCodeMark;
//# sourceMappingURL=japan-postal-code-mark.js.map